import React from 'react';
import { Box } from '@chakra-ui/react';
import PlanBillingSection from '../../components/PlanBillingSection';

const BillingPage: React.FC = () => {
  return (
    <Box minH="100%" py={{ base: 4, md: 6 }}>
      <PlanBillingSection />
    </Box>
  );
};

export default BillingPage;
